import {compact} from "@pg-mono/nodash";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IBreadcrumb} from "../../app/components/breadcrumbs/IBreadcrumb";
import {Country} from "../../region/types/Country";
import {abroadInvestmentOfferType, investmentOfferCountries} from "../constants/investment_offer_constants";

export const getAbroadOfferAndPropertyBreadcrumbs = (country: Country) => {
    const investmentOfferBreadcrumb = {
        key: "pod-inwestycje",
        name: "Pod inwestycje",
        url: rpAppLink.investmentOffer.landingPage()
    };
    const category = abroadInvestmentOfferType;
    const subcategory = investmentOfferCountries.find((type) => type.country === country);

    return compact<IBreadcrumb>([
        investmentOfferBreadcrumb,
        category
            ? {
                  key: category.namePlural,
                  name: category.namePlural,
                  url: rpAppLink.investmentOffer.investmentCategory.base({category: category.slug})
              }
            : null,
        category && subcategory
            ? {
                  key: subcategory.name,
                  name: subcategory.name,
                  url: rpAppLink.investmentOffer.investmentCategory.subcategory.base({
                      category: category.slug,
                      subcategory: subcategory.slug
                  })
              }
            : null
    ]);
};
import {compact} from "@pg-mono/nodash";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IBreadcrumb} from "../../app/components/breadcrumbs/IBreadcrumb";
import {Country} from "../../region/types/Country";
import {abroadInvestmentOfferType, investmentOfferCountries} from "../constants/investment_offer_constants";

export const getAbroadOfferAndPropertyBreadcrumbs = (country: Country) => {
    const investmentOfferBreadcrumb = {
        key: "pod-inwestycje",
        name: "Pod inwestycje",
        url: rpAppLink.investmentOffer.landingPage()
    };
    const category = abroadInvestmentOfferType;
    const subcategory = investmentOfferCountries.find((type) => type.country === country);

    return compact<IBreadcrumb>([
        investmentOfferBreadcrumb,
        category
            ? {
                  key: category.namePlural,
                  name: category.namePlural,
                  url: rpAppLink.investmentOffer.investmentCategory.base({category: category.slug})
              }
            : null,
        category && subcategory
            ? {
                  key: subcategory.name,
                  name: subcategory.name,
                  url: rpAppLink.investmentOffer.investmentCategory.subcategory.base({
                      category: category.slug,
                      subcategory: subcategory.slug
                  })
              }
            : null
    ]);
};
